import { API_BASE_URL } from '@synergy/config';
import { Box, Container, Stack, styled } from '@mui/material';
import { MarkdownConverter, PoolTypography } from '@synergy/components-next';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { ROUTES } from '../../utils/routes';
import { StaticSite } from '../../models/static-site';
import { StaticSitesApi } from '../../api/static-sites-api';
import { localesSelector } from '../../store/configuration-selectors';
import { mapStaticSite } from '../../models/mapper/static-site-mapper';
import { useAppSelector } from '../../../store/store';

const Wrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6),

    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(6, 0),
    },
}));

export const StaticSites = (): ReactElement | null => {
    const location = useLocation();
    const navigate = useNavigate();
    const locales = useAppSelector(localesSelector);
    const [staticSite, setStaticSite] = useState<StaticSite | null>(null);
    const api = useRef(new StaticSitesApi(API_BASE_URL)).current;

    useEffect(() => {
        api.getStaticSite(location.pathname).then(response => {
            if (!response.success) {
                setStaticSite(null);
                navigate(ROUTES.notFound);
            } else {
                setStaticSite(mapStaticSite(locales, response.result));
            }
        });
    }, [api, locales, location, navigate]);

    if (!staticSite) {
        return null;
    }

    return (
        <Container maxWidth="sm">
            <Wrapper>
                <Stack gap={6}>
                    <PoolTypography variant="h3">{staticSite.title}</PoolTypography>
                    <MarkdownConverter value={staticSite.text} />
                </Stack>
            </Wrapper>
        </Container>
    );
};
